module.exports = __webpack_public_path__ + "static/0052-f748a62c7135f91d009e6027b4d3632d.png";